module.exports = __webpack_public_path__ + "img/yishushengzhuce2.d26c20bb.png";